export enum Paths {
    // Main
    HOME = 'home',
    NOT_FOUND = 'not-found',

    // Auth
    AUTH = 'auth',
    LOGIN = 'login',
    LOGOUT = 'logout',
    CONFIRM_ACCOUNT = 'confirm-account',
    SIGNUP = 'signup',
    RESET = 'reset',
    PASSWORD_RESET = 'password-reset',
    BEXIO_ERROR = 'bexioError',
    RESET_INSTRUCTIONS = 'reset-instructions',
    EMAIL_VERIFICATION = 'email-verification',
    INVITATION = 'invitation',
    INVITATION_EXPIRED = 'invitation-expired',

    //ANNUALREPORT / Projects
    PROJECT = 'project',
    PROJECT_ID = ':id',
    GENERAL_INFORMATION = 'general',
    IMPORT = 'import',
    FINANCIAL_CLOSING_PROCESS = 'fcp',
    UPLOAD = 'upload',
    MAPPING = 'mapping',
    GROUPING_MASKING = 'grouping-masking',
    FX = 'fx',
    NOTES = 'notes',
    CFS = 'cash-flow-statement',
    NOTES_STEP = 'notes',
    AOP = 'aop',
    EQUITY_MOVEMENT_SCHEDULE = 'ems',
    FAS = 'fas',
    ADJUSTMENTS_AND_RECLASSES = 'adjustments-and-reclasses',
    COMPLEMENTARY_REPORTS = 'complementary-reports',
    PRINT = 'print',
    // REV-22155: person projects (mandate management only)
    PERSON_PROJECTS = 'person-projects',

    //TASKS
    TASKS = 'tasks',
    TASKS_OVERVIEW = 'overview',
    ANNOTATIONS = 'annotations',
    CLOSING_AND_TASKS = 'closing-and-tasks',
    DESIGN = 'design',

    //COMPANIES
    COMPANIES = 'companies',
    // REV-22155: natural persons
    PERSONS = 'persons',
    OVERVIEW = 'overview',
    PROFILE = 'profile',
    INTEGRATIONS = 'integrations',
    ANALYTICS = 'analytics',
    ADD = 'add',
    EDIT = 'edit',

    //COMPANY VALUATION
    COMPANY_VALUATION = 'company-valuation',
    CLOSING_PROCESS_ENABLING = 'closing-process',
    VALUATION_REPORT = 'valuation-report',

    //ORGANIZATION
    ORGANIZATION = 'organization',
    ORGANIZATION_SETTINGS = 'settings',
    ORGANIZATION_SETTINGS_NO_ACCESS = 'settings-no-access',
    SETTINGS = 'settings',
    TEXT_SNIPPETS = 'text-snippets',
    CHECKLISTS = 'checklists',
    WORKFLOW = 'workflow',
    MANDATE_MANAGEMENT = 'mandate-management',
    CLOSING_WORKFLOW_OVERVIEW = 'closing-workflow/overview',
    CLOSING_WORKFLOW_ID = 'closing-workflow/:id',
    CLOSING_WORKFLOW_NEW = 'closing-workflow/new',

    CLOSING_WORKFLOW = 'closing-workflow',
    REPORT_CPMM = ':id/cpmm',
    // REV-21518: sibling route tree of REPORT_CPMM. Same content pages, but hosted by AbcpPage
    // which renders the vertical (controlled) ham-navigation-bar instead of the horizontal tab nav.
    REPORT_ABCP = ':id/abcp',
    REPORT = 'report',

    // REV-21360: the "Jahresabschluss" module under `:id/abcp` — the workspace header (tab bar) plus
    // one child route per tab. The segments are the URL truth for the active tab; the pure view's
    // `HeaderTabId` uses camelCase for open-items, so ClosingPage maps between the two.
    CLOSING = 'closing',
    CLOSING_ACCOUNTS = 'accounts',
    // The accounts tab exists TWICE: one statement per address. Everything else under `closing` is
    // shared between the two, so only this tab splits.
    CLOSING_ACCOUNTS_BS = 'accounts-bs',
    CLOSING_ACCOUNTS_IS = 'accounts-is',
    // REV-21379 — the single-account child of the accounts tab.
    CLOSING_ACCOUNT_ID = ':accountId',
    CLOSING_DOCUMENTS = 'documents',
    // REV-21376 — the single-document child of the documents tab.
    CLOSING_DOCUMENT_ID = ':documentId',
    CLOSING_ADJUSTMENTS = 'adjustments',
    /**
     * REV-21375 — the DETAIL surface of one correction booking, as a CHILD of the tab.
     *
     * A child route for the same reason the single document is one: a row click navigates, so the deep
     * link, the reload, the back button and a shared URL all work without the host doing anything
     * special. `data.tabId` keeps the shell underlining `Korrekturbuchungen` while it is open.
     */
    CLOSING_ADJUSTMENT_ID = ':adjustmentId',
    CLOSING_OPEN_ITEMS = 'open-items',
    CLOSING_COMMENTS = 'comments',
    // REV-21354 — the Setup-Wizard. A SIBLING of the tabs, not one of them: it is where a
    // closing that has not started yet is sent, and the tab bar does not exist there.
    CLOSING_SETUP = 'setup',
    // REV-22479 — the Kontenplan: position and function per account, before the reconciliation.
    CLOSING_CHART_OF_ACCOUNTS = 'chart-of-accounts',
    // REV-22476 — the Jahresabschluss overview: where «Jahresabschluss» lands on a started closing.
    CLOSING_OVERVIEW = 'overview',

    ORGANIZATION_PROFILE = 'profile',
    ORGANIZATION_USERS = 'users',
    ORGANIZATION_SUBSCRIPTION = 'subscription',

    //USER
    USER_ACCOUNT = 'user',
    USER_GENERAL_INFORMATION = 'general',
    USER_SECURITY = 'security',

    // MFA
    ORGANIZATION_2FA = 'two-factor-auth',
    MFA_SETUP = 'setup',
    MFA_VERIFY = 'verify',
    AI_SETTINGS = 'ai-settings',
}
